<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import AntiFraudRequest from '@/app/modules/contacard/limits/antiFraud/AntiFraudRequest';
import DataTableCpfCnpjColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableCpfCnpjColumn.vue';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import AntiFraudLojaNameColumnVue from './components/AntiFraudLojaNameColumn.vue';
import AntiFraduProductNameColumnVue from './components/AntiFraduProductNameColumn.vue';

export default {
  name: 'AntiFraduList',
  extends: CrudListVue,
  data: () => ({
    requestClass: AntiFraudRequest,
    editRoute: 'antiFraud.edit',
    hideDelete: true,
    headers: [
      {
        text: 'Código',
        value: 'id',
      },
      {
        text: 'Usuário Cardmais',
        value: 'userSystemId',
      },
      {
        text: 'Cliente',
        value: 'clientName',
      },
      {
        text: 'Documento',
        value: 'clientDocument',
        component: DataTableCpfCnpjColumnVue,
      },
      {
        text: 'Transação',
        value: 'transaction',
      },
      {
        text: 'Loja',
        value: 'storeId',
        component: AntiFraudLojaNameColumnVue,
      },
      {
        text: 'Produto',
        value: 'productId',
        component: AntiFraduProductNameColumnVue,
      },
      {
        text: 'Data de criação',
        value: 'createdAt',
        component: DataTableDateColumnVue,
      },
    ],
  }),
  methods: {
    editAction(item) {
      this.goTo(
        'users.edit',
        {
          id: item.userId,
        },
      );
    },
    openUserTransaction() {
      return (user) => {
        if (user) {
          user.handleTab(1);
          user.$root.$emit('open-transaction-tab', true);
        }
      };
    },
  },
};
</script>
